<template>
  <div class="row no-space">
    <div class="center-vertical content-box-left-padding col-md-7">
      <img src="../assets/img/Hingstonsmile.png" alt="" style="width: 90%" />
    </div>
    <div class="content-box-right-padding col-md-5" style="z-index: 2">
      <p class="ath-title">ATH GAMES</p>
      <hr class="red-divider-thick sub-title-divider" />
      <div class="text-left">
        <p class="sub-title-text" style="margin-bottom: 1.5vw">
          ATHD TOKEN LAUNCH
        </p>
        <p class="text-m" style="margin-bottom: 1.5vw">
          <span class="bold">WE COULD TALK</span> and talk for ages about how
          extraordinarily talented we are, how our community-driven play-to-earn
          games will revolutionize the industry, but who has time for that?
          <span class="bold">NFT:s</span> never sleep, so let's just cut to the
          chase...
          <span class="bold break ath-launch-text"
            >...ATH GAMES’ FIRST TOKEN LAUNCH!</span
          >
        </p>
        <p class="copy-text">TOKEN ADDRESS</p>
        <button
          id="copyAddressButton"
          class="red-button"
          @click.prevent="copyTokenAddress()"
        >
          0x632a21a913a4b59b561b999cf473109e37e87b39 <i class="far fa-copy"></i>
        </button>
        <b-popover
          custom-class="copy-pop-over"
          target="copyAddressButton"
          triggers="focus"
        >
          <span class="bold">COPIED!</span>
        </b-popover>
        <div class="red-box center-horizontal center-vertical">
          <h2 style="text-align: center">
            ATHD TOKEN <span class="break">NOW LIVE!</span>
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      date: Date.parse("2021-12-11T23:59:00+01:00") / 1000,
    };
  },
  methods: {
    goToWhiteList() {
      window.open("https://gleam.io/0I80w/whitelist-competition-ath-games");
    },
    copyTokenAddress() {
      navigator.clipboard.writeText(
        "0x632a21a913a4b59b561b999cf473109e37e87b39"
      );
    },
    hrExpandRight() {
      var windowWidth = $(window).width();
      $("#expandRight")
        .width(windowWidth)
        .css("margin-right", function () {
          return "-" + $(this).offset().left + "px";
        });
    },
  },
  mounted() {
    $(".nav-item a").removeClass("router-link-active");
    $("#navItemATH a").addClass("router-link-active");
  },
};
</script>

<style scoped>
.hr:after {
  width: 200%;
}

.text-m {
  line-height: 120%;
}
.tba-text {
  font-size: clamp(10px, 4vw, 70px);
  padding-bottom: 0.5em;
}
#video {
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.red-box {
  background-color: var(--red);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.3) 0px 15px 12px;
  border-radius: 0.5vw;
}
.text-expand {
  text-align: justify;
}
.sub-title-divider {
  font-size: clamp(1.3rem, 4.5vw, 110px);
  width: 200%;
}

.red-button {
  padding: 0.1em !important;
  width: 100%;
  border-radius: 0.5vw;
  font-size: clamp(8px, 1.2vw, 60px);
  margin-bottom: 1vw;
}

.ath-title {
  text-align: left;
  font-size: clamp(14px, 4.6vw, 190px);
  font-weight: 600;
  letter-spacing: 0.09em;
  margin-bottom: -1.8vw;
  padding-top: -5vw !important;
}

.ath-launch-text {
  text-align: right;
}

.sub-title-text {
  text-align: left;
  letter-spacing: 0.1em;
  font-size: clamp(10px, 2.5vw, 130px);
  margin-top: -0.5vw;
}

.copy-text {
  text-align: center;
  margin-bottom: -0.2vw;
  font-size: clamp(10px, 1.3vw, 3.6rem);
}

.title-box-container {
  display: grid;
  grid-template-columns: 60% 40%;
  position: relative;
}

@media (max-width: 992px) {
  .title-box-container {
    min-height: auto;
    grid-template-columns: 40% 60%;
  }
  .red-button {
    padding: 0.5em !important;
  }
  .text-expand {
    text-align: unset;
  }
  .ath-launch-text {
    text-align: left;
  }
}
</style>
